import React from "react";
import { Link } from "react-router-dom";
import Logo from "../components/common/Logo";

export const AccessDenied: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
      <Link to="/" className="mb-8">
        <Logo />
      </Link>
      <div className="text-center max-w-md">
        <h1 className="text-2xl font-semibold text-gray-900 mb-2">
          Access denied
        </h1>
        <p className="text-gray-600 mb-8">
          Your account doesn't have permission for this store or feature.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/my-restaurants"
            className="inline-flex justify-center items-center px-4 py-2 rounded-md bg-indigo-600 text-white font-medium hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Back to Dashboard
          </Link>
          <Link
            to="/my-restaurants"
            className="inline-flex justify-center items-center px-4 py-2 rounded-md border border-gray-300 bg-white text-gray-700 font-medium hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Switch restaurant
          </Link>
        </div>
      </div>
    </div>
  );
};
